import {InvoicePaymentLogModalHeader} from './InvoicePaymentLogModalHeader'

interface IInvoiceInfo {
  dataPaymentLog?: any
  onClose?: () => void
}

const InvoicePaymentLogModal = ({dataPaymentLog, onClose}: IInvoiceInfo) => {
  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        <div className='modal-dialog modal-dialog-centered mw-950px'>
          <div className='modal-content'>
            <InvoicePaymentLogModalHeader onClose={onClose} />

            <div className='card shadow-sm border-0 rounded-4'>
              <div className='card-body p-5'>
                <table className='table table-row-dashed table-row-gray-300 gy-7'>
                  <thead>
                    <tr className='fw-bolder fs-6 text-gray-800'>
                      <th>Dt processamento</th>
                      <th>N Cartão</th>
                      <th>Bandeira</th>
                      <th>Status</th>
                      <th>Motivo</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dataPaymentLog?.map((paymentLog: any) => (
                      <tr key={paymentLog.id}>
                        <td>{paymentLog.createdAt}</td>
                        <td>
                          {paymentLog.creditCard?.firstNumbers}****
                          {paymentLog.creditCard?.lastNumbers}
                        </td>
                        <td>{paymentLog.creditCard?.brand?.description}</td>
                        <td>{paymentLog.status}</td>

                        <td>
                          {paymentLog.returnCode == '00'
                            ? 'Capturado'
                            : `Erro: ${paymentLog.returnCode}`}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='modal-backdrop fade show'></div>
    </>
  )
}

export {InvoicePaymentLogModal}
